export const DT = {
  darkBg: '#0A1A0F',
  surface: '#1A2E1F',
  primaryText: '#F0F9F2',
  winning: '#00E676',
  losing: '#FBBF24',
  doubleBogey: '#FF5252',
  gold: '#FFD740',
  interactive: '#69F0AE',
  brandEmerald: '#064E3B',
  divider: '#4A7A5C',
  team1Bg: 'rgba(0, 230, 118, 0.08)',
  team2Bg: 'rgba(6, 78, 59, 0.35)',
  // Opaque equivalents of team backgrounds composited on DT.surface (#1A2E1F).
  // Required for sticky cells — semi-transparent backgrounds let scrolled hole
  // cells bleed through the pinned label column.
  // team1Bg composited: rgba(0,230,118,0.08) over rgb(26,46,31) → rgb(24,61,38)
  team1StickyBg: '#183D26',
  // team2Bg composited: rgba(6,78,59,0.35) over rgb(26,46,31) → rgb(19,57,41)
  team2StickyBg: '#133929',
  winBg: 'rgba(0, 230, 118, 0.12)',
  loseBg: 'rgba(251, 191, 36, 0.12)',
  pressBg: 'rgba(105, 240, 174, 0.08)',
} as const;

export function dtDollarColor(amount: number): string {
  if (amount > 0) return DT.winning;
  if (amount < 0) return DT.losing;
  return DT.primaryText;
}

export function dtScoreColor(score: number, par: number): string {
  if (score < par) return DT.winning;
  if (score === par + 1) return DT.losing;
  if (score >= par + 2) return DT.doubleBogey;
  return DT.primaryText;
}

export function dtStatusColor(status: number): string {
  if (status > 0) return DT.winning;
  if (status < 0) return DT.losing;
  return DT.primaryText;
}

export function dtStatusBg(status: number): string {
  if (status > 0) return DT.winBg;
  if (status < 0) return DT.loseBg;
  return DT.darkBg;
}
